"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiAutocompleteOverrides = void 0;
var createMuiAutocompleteOverrides = function (_a) {
    var spacing = _a.spacing, palette = _a.palette;
    return ({
        inputRoot: {
            '&[class*="MuiOutlinedInput-root"]': {
                padding: undefined,
                "& $input": {
                    padding: undefined,
                },
                "& $input:first-child": {
                    paddingLeft: undefined,
                },
            },
            '&[class*="MuiOutlinedInput-root"][class*="MuiOutlinedInput-marginDense"] $input': {
                padding: undefined,
            },
            // Regular without label
            padding: spacing(4),
            // Regular with label
            "label + &": {
                padding: spacing(5.5, 4, 1.5),
                "& > div": {
                    margin: spacing(0.5, 1, 0.5, 0),
                    maxWidth: "100%",
                },
                "& > $input": {
                    padding: 0,
                },
            },
        },
        input: {
            padding: 0,
            height: "auto",
            lineHeight: 1.79,
        },
        paper: {
            backgroundColor: palette.background.overlays,
            boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.35);",
        },
        option: {
            color: palette.text.secondary,
            // Paddings have to be overwritten separately because original styles also define them like this.
            // i.e. padding: spacing(2, 4) won't work
            paddingTop: spacing(2),
            paddingBottom: spacing(2),
            paddingLeft: spacing(4),
            paddingRight: spacing(4),
            // Hover
            '&[data-focus="true"]': {
                color: palette.text.primary,
                backgroundColor: palette.action.hover,
            },
            // Selected
            '&[aria-selected="true"]': {
                color: palette.text.primary,
                backgroundColor: palette.action.selected,
            },
        },
    });
};
exports.createMuiAutocompleteOverrides = createMuiAutocompleteOverrides;
//# sourceMappingURL=MuiAutocomplete.js.map